import '../../App.css'

import React from 'react'
import { useAuth } from '../../contexts/AuthContext.js'
import "./Home.css"

import { InstagramIcon, DiscordIcon, LinkedInIcon } from './logos.js'

import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/css/image-gallery.css";

const Home = () => {
    const { currentUser } = useAuth();
    const sculc_images = [
        {
            original: "/images/sculc-images/sculc-img-1.png",
        },
        {
            original: "/images/sculc-images/sculc-img-2.png",
        },
        {
            original: "/images/sculc-images/sculc-img-3.png",
        },
        {
            original: "/images/sculc-images/sculc-img-4.png",
        }
    ];
    return (
        <div className="home-page">
            <div style={{ display: "block" }}>
                <div className="hero-image">
                    <img src="/images/bruin-linguists-logo.png" alt="Bruin Linguists Society" />
                </div>
                <div className="hero">
                    <h1 className="definition">
                        linguistics <span className="ipa mlmr">[lɪŋˈgwɪs tɪks]</span> <i className="mlmr">noun</i> the scientific study of language
                    </h1>
                </div>
                <div className="content">
                    <div style={{ maxWidth: "1000px" }}>

                            <div className="description-item">
                                <img
                                    src="/images/wug-left.png"
                                    alt="BLing Wug"
                                    className="wug-popup"
                                />
                                 <h2 style={{ fontSize: "1.3rem", fontWeight: "bold", marginBottom: "1rem" }}>The home of the Linguistics Community at UCLA</h2>
                                <p className="description-home">The Bruin Linguists Society (BLing) is the UCLA Linguistics’ undergraduate student association. We host events every quarter that are geared towards undergraduate students’ success in career, academics, and the linguistics community. Check out our upcoming <a href="/events">events</a> or stay updated by joining our <a href="#mc_embed_signup">mailing list</a>!</p>
                            </div>

                                <div id="mc_embed_signup" className="mailing-list-home">
    <form
        action="https://facebook.us20.list-manage.com/subscribe/post?u=5689bdbfc1e32a9a525a9cf2c&id=27d46ef417&f_id=003017e7f0"
        method="post"
        target="_blank"
    >
        <h2 style={{ fontSize: "1.3rem", fontWeight: "bold", marginBottom: "0.5rem" }}>Subscribe to our newsletter!</h2>
        <input type="email" name="EMAIL" placeholder="Email address *" required className="mailing-input" />
        <input type="text" name="NAME" placeholder="Name" className="mailing-input" />
        <input type="hidden" name="tags" value="3478163" />
        {/* anti-bot field: must stay hidden */}
        <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
            <input type="text" name="b_5689bdbfc1e32a9a525a9cf2c_27d46ef417" tabIndex="-1" defaultValue="" />
        </div>
        <button type="submit" className="mailing-button">Subscribe</button>
    </form>
</div>
                        <div className="social-icons">
                            <a
                                href="https://www.instagram.com/bruinlinguists/"
                                target="_blank"
                                rel="noopener noreferrer">
                                <InstagramIcon />
                            </a>
                            <a
                                href="https://discord.gg/NPVpyDw"
                                target="_blank"
                                rel="noopener noreferrer">
                                <DiscordIcon />
                            </a>
                            <a
                                href="https://www.linkedin.com/groups/13891251/"
                                target="_blank"
                                rel="noopener noreferrer">
                                <LinkedInIcon />
                            </a>
                        </div>

                        <div className="split-bottom">
                            <div style={{ maxWidth: "400px" }} className='item'>
                                <h2 style={{ fontSize: "1.3rem", fontWeight: "bold", marginBottom: "1rem" }}>Southern California Undergraduate Linguistics Conference (SCULC)</h2>
                                <p style={{ textAlign: "left" }}>Among the events that BLing puts on every year is the Southern California Undergraduate Linguistics Conference (SCULC), where we host undergraduates to present their research from universities both here and abroad. Last year we hosted 19 undergraduate researchers from 
Harvard, Stony Brook University, Obafemi Awolowo University, BYU, CSU Northridge, UCLA, UCSD, UCSB, UCI, and UC Berkeley.</p>
                                <br/>
                            </div>
                            <div style={{ width: "100%" }} className='item'>
                                {/* <img src="/images/sculc-images/sculc-img-1.png" alt="SCULC" style={{width: "100%"}} /> */}
                                <ImageGallery items={sculc_images} showThumbnails={false} showPlayButton={false} />
                            </div>
                        </div>

                    </div>
                </div>

                {/* <div className="content footer">
                    <div className="split" style={{ maxWidth: "1000px"}}>
                        <div>
                            <p>Email us at <a href="mailto:wug@linguistics.net">wug@linguistics.net</a></p>
                        </div>
                        <div className="split">
                            <a>Instagram</a>
                            <a>Discord</a>
                            <a>LinkedIn</a>
                            <a>Mailing List</a>
                        </div>

                    </div>
                </div> */}
                {/* <div className='text-2xl font-bold pt-14'>{currentUser ? currentUser.displayName : "Not logged in"}</div> */}
            </div>
        </div>
    )
}

export default Home

